<template>
    <div class="col-12 text-center" :class="subMenu == true ? 'col-md-6' : 'col-md-8 offset-md-2'" id="interactiveMenu" ref="InteractiveMenu">
        <h2 class="mt-3">Need To Call Us?</h2>
        <p>To help you, we need to ask a few questions first</p>
        <hr>
        <b class="d-block mb-3">Is your query regarding a new order or existing order?</b>
        <div class="groupOne">
            <button type="button" class="btn me-2" :class="btnInactive" @click="e => toggleSection(e, 'newOrder', 'groupOne', false)">New Order</button>
            <button type="button" class="btn" :class="btnInactive" @click="e => toggleSection(e, 'existingOrder', 'groupOne', false)">Existing Order</button>
        </div>
        <Transition mode="out-in" appear>
            <div v-if="visibleSection == 'newOrder'">
                <p class="mt-3">Unfortunately our customer service team can't  place orders manually over the phone for you. You will need to place an order online first.</p>
            </div>
            <div v-else-if="visibleSection == 'existingOrder' || visibleSection == 'garageFitting' || visibleSection == 'Yes' || subMenu">
                <hr>
                <b class="d-block mb-2">What type of fitting is your order?</b>
                <div class="groupTwo">
                    <button v-if="mobileFaqs.length > 0" type="button" class="d-inline-block btn" :class="btnInactive" @click="e => toggleSection(e, 'mobileFitting', 'groupTwo', true)">Mobile Fitting</button>
                    <button v-if="garageFaqs.length > 0" type="button" class="d-inline-block btn mx-3 my-2" :class="btnInactive" @click="e => toggleSection(e, 'garageFitting', 'groupTwo', false)">Garage Fitting</button>
                    <button v-if="homeDeliveryFaqs.length > 0" type="button" class="d-inline-block btn" :class="btnInactive" @click="e => toggleSection(e, 'homeDelivery', 'groupTwo', true)">Home Delivery</button>
                </div>
            </div>
        </Transition>
        <Transition mode="out-in" appear>
            <div v-if="visibleSection == 'garageFitting' || visibleSection == 'Yes' || visibleSection == 'No'">
                <hr>
                <b class="d-block mb-3">Are you currently at the garage/fitting centre?</b>
                <div class="groupThree">
                    <button type="button" class="btn me-2" :class="btnInactive" @click="e => toggleSection(e, 'Yes', 'groupThree', false)">Yes</button>
                    <button type="button" class="btn" :class="btnInactive" @click="e => toggleSection(e, 'No', 'groupThree', true)">No</button>
                </div>
                <div v-if="visibleSection == 'Yes'">
                    <p class="mt-3">You can call our fitter service team on <a href="tel:{{ customerServiceNumber }}">{{ customerServiceNumber }}</a>.</p>
                    <p>Please be aware this team will only deal with queries whilst you're at the fitter.</p>
                </div>
            </div>
        </Transition>
    </div>
    <div v-if="subMenu" class="col-12 col-md-6 border-start">
        <Transition name="fade" mode="out-in" appear>
            <div v-if="visibleSection == 'mobileFitting'">
                <MobileFitting
                    v-if="mobileFaqs.length > 0"
                    :customer-service-number="customerServiceNumber"
                    :faqs="mobileFaqs"
                    :accordion-bg="accordionBg"
                ></MobileFitting>
            </div>
            <div v-else-if="visibleSection == 'No'">
                <GarageFitting
                    v-if="garageFaqs.length > 0"
                    :customer-service-number="customerServiceNumber"
                    :faqs="garageFaqs"
                    :btn-active="btnActive"
                    :btn-inactive="btnInactive"
                    :accordion-bg="accordionBg"
                ></GarageFitting>
            </div>
            <div v-else-if="visibleSection == 'homeDelivery'">
                <HomeDelivery
                    v-if="homeDeliveryFaqs.length > 0"
                    :customer-service-number="customerServiceNumber"
                    :faqs="homeDeliveryFaqs"
                    :accordion-bg="accordionBg"
                ></HomeDelivery>
            </div>
        </Transition>
    </div>
    <div ref="InteractiveMenuBottom"></div>
</template>

<script>
    export default {
        props: [
            'customerServiceNumber',
            'garageFaqs',
            'mobileFaqs',
            'homeDeliveryFaqs',
            'btnActive',
            'btnInactive',
            'accordionBg'
        ],
        data() {
            return {
                visibleSection: '',
                subMenu: false
            }
        },
        methods: {
            toggleSection(e, section, group, subMenu) {
                let vm = this;
                var elems = document.querySelectorAll('.' + group + ' .' + this.btnActive);

                [].forEach.call(elems, function(el) {
                    el.classList.remove(vm.btnActive);
                    el.classList.add(vm.btnInactive);
                });

                e.target.classList.remove(this.btnInactive);
                e.target.classList.add(this.btnActive);

                const el = this.$refs.InteractiveMenu;

                this.subMenu = subMenu;
                this.visibleSection = section;

                el.scrollIntoView({behavior: 'smooth'});
            },
        }
    }
</script>

<style lang="scss" scoped>
    .v-enter-active,
    .v-leave-active {
        transition: opacity 0.5s ease;
    }

    .v-enter-from,
    .v-leave-to {
        opacity: 0;
    }
</style>